import { render } from "./newInvoice.vue?vue&type=template&id=dad9de6e"
import script from "./newInvoice.vue?vue&type=script&lang=js"
export * from "./newInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__